<template>
  <el-dialog
    title="特殊核销"
    :visible="visible"
    :before-close="closeDialog"
    width="50%">

    <el-form label-width="96px"
             ref="body"
             :model="body"
             :rules="forceFinishRules"
             label-position="right"
             size="medium">
      <div class="re-el-form__flex">

        <el-form-item prop="reason"
                      label="核销说明"
                      min-width="120">
          <el-input v-model="body.reason"
                    placeholder="请输入核销说明"></el-input>
        </el-form-item>

        <el-form-item label="附件"
                      prop="attached_file">
          <el-upload
            class="upload-demo"
            action=""
            :auto-upload="false"
            :on-change="(file, fileList) => {onChangeFile(file, fileList, this.body.attached_file)}"
            :before-remove="(file, fileList) => {beforeRemove(file, fileList, this.body.attached_file)}"
            multiple
            :limit="20"
            :on-exceed="(file, fileList) => {handleExceed(file, fileList, 20)}"
            :file-list="fileList"
            ref="upload"
            accept=".jpg, .jpeg, .png, .pdf, .eml, .html, .htm, .xls, .xlsx, .doc, .docx, .zip"
          >
            <el-tooltip class="item"
                        effect="dark"
                        content="点击上传附件"
                        placement="right">
              <el-button size="small"
                         :loading="loadingFileUpload"
                         type="primary">点击上传
              </el-button>
            </el-tooltip>
            <div slot="tip"
                 class="el-upload__tip">请上传PNG/JPG/PDF/EML/HTML/WORD/EXCEL/ZIP文件，仅支持上传20个文件，20以上建议上传zip格式
            </div>
          </el-upload>
        </el-form-item>

      </div>
      <el-form-item>
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="onSubmit" :disabled="loadingFileUpload">确认
        </el-button>
      </el-form-item>
    </el-form>

  </el-dialog>
</template>

<script>
import { forceFinishRules } from '../received-payment.rules.js'

export default {
  props: {
    visible: Boolean,
    collectionData: Object,
  },
  data () {
    return {
      id: 0,
      forceFinishRules,
      body: {
        reason: null,
        attached_file: [],
      },
      fileList: [],
      current_collection: {},
      loadingFileUpload: false,
    }
  },
  computed: {},
  watch: {
    collectionData: {
      handler (val) {
        this.current_collection = val
        this.id = val.id
      },
    },
  },
  created () {},
  mounted () {},
  methods: {
    handleExceed (files, fileList, max) {
      this.$message.warning(`当前限制选择 ${max} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    beforeRemove (file, fileList, formField) {
      let fileTemp
      if (file.raw) {
        fileTemp = file.raw
      } else {
        fileTemp = file
      }
      let index = this.getFileListIndex(fileTemp, fileList)
      if (index > -1) {
        formField.splice(index, 1)
      }
    },
    getFileListIndex (file, fileList) {
      for (let i = 0; i < fileList.length; i++) {
        let fileTemp
        if (fileList[i].raw) {
          fileTemp = fileList[i].raw
        } else {
          fileTemp = fileList[i]
        }
        if (file === fileTemp) {
          return i
        }
      }
      return -1
    },
    onChangeFile (file, fileList, formField) {
      let isLt5M = file.raw.size / 1024 / 1024 < 50
      if (!isLt5M) {
        this.$message.error('文件内容必须小于50MB!')
        this.$refs.upload.uploadFiles.pop()
        return false
      }
      this.onUploadFile(file.raw, fileList, formField)
    },
    onUploadFile (file, fileList, formField) {
      this.loadingFileUpload = true

      let formData = new FormData()
      formData.append('file', file)
      this.id && formData.append('apply_id', this.id)
      return request.alert('finCenterUploadPaymentApplyFile', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        let index = this.getFileListIndex(file, fileList)

        let type = file.name.split('.').pop().toLowerCase()
        if (['jpeg', 'jpg', 'png'].includes(type)) {
          type = 'pic'
        } else if (['pdf'].includes(type)) {
          type = 'pdf'
        } else if (['eml', 'html', 'htm'].includes(type)) {
          type = 'eml'
        } else if (['xlsx', 'doc', 'docx'].includes(type)) {
          type = 'office'
        } else if (['zip'].includes(type)) {
          type = 'zip'
        }
        if (index > -1) {
          formField[index] = {name: file.name, url: data, type: type}
        }
        this.loadingFileUpload = false
      }).catch(_ => {
        this.$refs.upload.uploadFiles.pop()
        this.loadingFileUpload = false
      })
    },
    closeDialog () {
      this.id = 0
      Object.assign(this.$data, this.$options.data.call(this))
      this.$emit('closeDialog')
    },
    closeAndRefresh () {
      this.closeDialog()
      this.$emit('refreshPage')
    },
    onSubmit () {
      this.$refs['body'].validate((valid) => {
        if (valid) {
          const confirmText = [
            '请确认操作当前特殊核销',
            `回款ID：${this.current_collection.id}`,
            `待核销金额：${this.current_collection.remain_amount_total}`,
            `已核销金额：${this.current_collection.related_amount_total}`,
          ]
          let newMsg = []
          const h = this.$createElement
          for (const i in confirmText) {
            newMsg.push(h('p', null, confirmText[i]))
          }
          this.$confirm('', '确认特殊核销',
            {
              message: h('div', null, newMsg),
              confirmButtonText: '确认',
              cancelButtonText: '取消',
            }).then(() => {
            request.common('forceFinishCollection', {id: this.id, ..._.cloneDeep(this.body)}).then((res) => {
              this.$confirm('特殊核销成功', '提示', {type: 'success'}).then(() => {
                this.closeAndRefresh()
              }, () => {
                this.closeAndRefresh()
              })
            })
          }, () => {
            this.closeDialog()
          })
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
  }
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/received-payment/components/ForceFinishDialog.vue